export interface RootNavigationObject {
  general: ISidebarData
  long_stay_permit: ISidebarData
}

export interface ISidebarData {
  title: string
  routes: INavigationRoute[]
}

export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  general: {
    title: 'General',
    routes: [
      {
        name: 'services',
        displayName: 'Services',
        meta: {
          icon: 'language',
        },
      },
      {
        name: 'FAQ',
        displayName: 'FAQ',
        meta: {
          icon: 'quiz',
        },
      },
    ],
  },
  management: {
    title: 'Account',
    routes: [
      {
        name: 'settings',
        displayName: 'Application Settings',
        meta: {
          icon: 'settings',
        },
      },
    ],
  },
  long_stay_permit: {
    title: 'Long Stay Permit',
    routes: [
      {
        name: 'LSP-HOME',
        displayName: 'Dashboard',
        meta: {
          icon: 'home',
        },
      },
      {
        name: 'LSP-APPLIST',
        displayName: 'My Applications',
        meta: {
          icon: 'view_list',
        },
      },
      {
        name: 'lsp-orders',
        displayName: 'Payment History',
        meta: {
          icon: 'payments',
        },
      },
      {
        name: 'lsp-qualify',
        displayName: 'Do I Qualify',
        meta: {
          icon: 'quiz',
        },
      },
      {
        name: 'FAQ',
        displayName: 'FAQ',
        meta: {
          icon: 'quiz',
        },
      },
    ],
  },
}
